<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">广告名：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">广告ID：</div>
        <el-input v-model="filters.adid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">负责人：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists" :filterLists.sync="operFilterLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
      <div class="ml-auto">
        <router-link class="blue-small-btn mr-20" :to="{path: '/adUserConf'}">配置用户折扣</router-link>
        <router-link class="blue-small-btn" :to="{path: '/adEdit', query: {adid: 0}}">新建</router-link>
      </div>
    </div>

    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" height="600">
      <!-- ✅ 正确循环写法（和你参考代码完全一致） -->
      <el-table-column
        v-for="(col, index) in tableColumns"
        :key="`${col.columnName}-${index}`"
        :prop="col.columnName"
        :label="col.columnTitle"
        align="center"
        :width="col.width"
        v-if="col.isShow"
      >
        <!-- 表头双击打开列设置 -->
        <template slot="header" slot-scope="scope">
          <span @dblclick="isShowColumn = true">
            <i v-if="index === 0" class="el-icon-setting" style="cursor:pointer;margin-right:4px" @click="isShowColumn = true"></i>
            {{ col.columnTitle }}
          </span>
        </template>
        <!-- 内容区域（只匹配对应列渲染） -->
        <template slot-scope="scope">
          <!-- 交单链接/囤货链接/固返链接 -->
          <el-button v-if="['upload_url', 'store_upload_url', 'fixed_upload_url', 'corp_upload_url'].includes(col.columnName)"
            type="primary" icon="el-icon-document-copy" size="mini" class="copy-btn"
            @click="copyLink" :data-clipboard-text="scope.row[col.columnName]"></el-button>

          <!--
          <div v-else-if="col.columnName === 'fixed_upload_url'">
            <el-popover
              placement="right"
              width="40"
              trigger="click">
              <div class="flex fdc jcc aic">
                <el-button type="primary" size="mini" plain class="ml-10 mb-20" @click="copyText(scope.row.fixed_upload_url)">固返链接</el-button>
                <el-button type="primary" size="mini" plain class="" @click="copyText(scope.row.predict_upload_url)">预约链接</el-button>
              </div>

              <el-button slot="reference" size="mini">显示</el-button>
            </el-popover>
          </div>
          -->
          <!-- 状态 -->
          <div v-else-if="col.columnName === 'status'" class="flex aic">
            <div v-if="scope.row.status == 2" class="normal-btn">完结</div>
            <div v-if="scope.row.status == 1" class="blue-small-btn" @click="changeAdStatus(scope.$index)">运行</div>
            <div v-if="scope.row.status == 0" class="red-small-btn" @click="changeAdStatus(scope.$index)">下架</div>
          </div>

          <!-- 首页显示 -->
          <div v-else-if="col.columnName === 'home'">
            <div v-if="scope.row.home == 1" class="normal-btn">是</div>
            <div v-if="scope.row.home == 0" class="danger-btn">否</div>
          </div>

          <!-- 订单数/有效数 -->
          <span v-else-if="col.columnName === 'order_num'">{{ scope.row.order_num }}/{{ scope.row.ocount }}</span>

          <!-- 额度相关 -->
          <span v-else-if="['quota', 'remain_quota', 'tquota'].includes(col.columnName)">
            <div v-if="scope.row.mode == 0" >{{ scope.row[col.columnName] }}</div>
            <div v-if="scope.row.mode == 1" >{{ scope.row[col.columnName] }}单</div>
          </span>

          <!-- 金额相关 -->
          <span v-else-if="col.columnName === 'payment'">{{ scope.row.payment }}/{{ scope.row.invalid_quota }}</span>
          <span v-else-if="col.columnName === 'tpayment'">{{ scope.row.tpayment }}/{{ scope.row.invalid_tquota }}</span>
          <span v-else-if="col.columnName === 'remain_tquota'">{{ scope.row.remain_tquota }}</span>

          <!-- 下载 -->
          <el-button v-else-if="col.columnName === 'download'"
            type="primary" icon="el-icon-download" size="mini"
            @click="download(scope.row.adid)"></el-button>

          <!-- 创建时间 -->
          <span v-else-if="col.columnName === 'create_time'" v-html="formatTimeStamp(scope.row.create_time)"></span>

          <!-- 普通列直接显示 -->
          <span v-else>{{ scope.row[col.columnName] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <router-link class="blue-small-btn" :to="{path: '/adDetail', query: {adid: scope.row.adid}}">明细</router-link>
            <router-link class="blue-small-btn ml-10" :to="{path: '/adEdit', query: {adid: scope.row.adid}}">编辑</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>

    <!-- 列设置组件 -->
    <TableColumnSetting
      :visible.sync="isShowColumn"
      :column-list.sync="tableColumns"
      :default-columns="defaultColumns"
      :storage-key="`${$options.name}_table_columns`"
    />
  </article>
</template>

<script>
import Clipboard from 'clipboard'
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {adLists, adEdit, downloadAdOrderLists} from '../../../api/api'
import operSelect from '../../../components/data-select/operSelect.vue'

export default {
  name: 'adList',
  mixins: [mixinList],
  components: {
    operSelect
  },
  data () {
    return {
      statusList: [
        { name: '所有', value: '' },
        { name: '运行', value: 1 },
        { name: '下架', value: 0 },
        { name: '完结', value: 2 }
      ],
      lists: [],
      listLoading: false,
      operLists: [],
      operFilterLists: [1, 4, 5, 16],
      isShowColumn: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        title: '',
        opid: '',
        status: ''
      },
      defaultColumns: [
        { columnName: 'adid', columnTitle: 'ID', isShow: true },
        { columnName: 'title', columnTitle: '广告名', isShow: true },
        { columnName: 'oper_nickname', columnTitle: '负责人', isShow: true },
        { columnName: 'upload_url', columnTitle: '交单链接', isShow: true },
        { columnName: 'store_upload_url', columnTitle: '囤货链接', isShow: true },
        { columnName: 'fixed_upload_url', columnTitle: '固定链接', isShow: true },
        { columnName: 'corp_upload_url', columnTitle: '对公链接', isShow: true },
        { columnName: 'aver_discount', columnTitle: '上家折扣', isShow: true },
        { columnName: 'min_discount', columnTitle: '底价折扣', isShow: true },
        { columnName: 'discount', columnTitle: '用户折扣', isShow: true },
        { columnName: 'status', columnTitle: '状态', isShow: true, width: '90'},
        { columnName: 'home', columnTitle: '首页显示', isShow: true },
        { columnName: 'remark', columnTitle: '备注', isShow: true },
        { columnName: 'order_num', columnTitle: '订单数/有效数', isShow: true },
        { columnName: 'quota', columnTitle: '总额度', isShow: true },
        { columnName: 'payment', columnTitle: '总报单/丢单金额', isShow: true },
        { columnName: 'remain_quota', columnTitle: '总剩余额度', isShow: true },
        { columnName: 'tquota', columnTitle: '当日额度', isShow: true },
        { columnName: 'tpayment', columnTitle: '当日报单/丢单金额', isShow: true },
        { columnName: 'remain_tquota', columnTitle: '当日剩余额度', isShow: true },
        { columnName: 'download', columnTitle: '下载', isShow: true },
        { columnName: 'create_time', columnTitle: '创建时间', isShow: true, width: '100' }
      ],
      tableColumns: []
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    changeAdStatus (index) {
      let status = this.lists[index].status
      let adid = this.lists[index].adid

      status = this.lists[index].status === 1 ? 0 : 1

      let params = {
        status: status,
        adid: adid
      }

      adEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.adid !== '') {
        params.adid = filters.adid
      }

      if (filters.title !== '') {
        params.title = filters.title
      }

      if (filters.opid !== '') {
        params.opid = filters.opid
      }

      if (filters.status !== '') {
        params.status = filters.status
      }

      this.listLoading = true
      adLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    download (adid) {
      let link = downloadAdOrderLists + '?choose=' + 4
      link = link + '&adid=' + adid
      window.open(link, 'a')
    },
    async copyText(text) {
      try {
        await util.copyText(text)
        this.$message.success('复制成功')
      } catch (msg) {
        this.$message.warning(msg)
      }
    },
    copyLink () {
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success'
        })

        // 释放内存
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        this.$notify({
          title: '失败',
          message: '复制失败',
          type: 'error'
        })

        // 释放内存
        clipboard.destroy()
      })
    },
    filterParamsChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.adid': 'filterParamsChange',
    'filters.opid': 'filterParamsChange',
    'filters.title': 'filterParamsChange',
    'filters.status': 'filterParamsChange'
  },
  mounted () {
    this.getList()
    util.setCookie('createAddetail', '')
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/ad/adList.vue